import { classes, DOM } from '../const';

const { $hbody, $document } = DOM;
const { noOverflow, isHidden, isActive } = classes;

const $$modalLinks = $('.js-modal-link');
const $$modals = $('.js-modal');


const openModal = ($el, videoUrl, initiator)  => {
  const $$frames = $el.find('.js-modal-iframe');
  let $$cookieName = '';
  if (videoUrl) {
    $$cookieName = 'video';
  } else if ($$frames.find('.cookie_2click').length > 0) {
    $$cookieName = $$frames.find('.cookie_2click').attr('data-cookie');
  }

  let cookieValues = ''

  const nameEQ = "externalSources=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    if (c.indexOf(nameEQ) === 0) {
      cookieValues = c.substring(nameEQ.length, c.length);

      break;
    }
    while (c.charAt(0) === ' ') {

      c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        cookieValues = c.substring(nameEQ.length, c.length);

        break;
      }
    }
  }

  let allowedByCookie = false;
  if ($('body').hasClass('is-IE')) {
    if (cookieValues.split(',').indexOf($$cookieName) > 0) {
      allowedByCookie = true;
    } else {
      allowedByCookie = false;
    }
  } else {
    allowedByCookie = cookieValues.split(',').includes($$cookieName)
  }

  $$frames.each((i, frame) => {
    if ((allowedByCookie && $$cookieName !== '') || !$(frame).hasClass('cookieClick')) {
        const url = $(frame).data('frame-url');
        $(frame).html('');
        $(frame).append(`<iframe src="${url}" frameborder="0" allowfullscreen allow="xr-spatial-tracking" />`);
        $(frame).append($(frame).closest('.js-modal').find('.modal_revoke').html())
        $(frame).closest('.js-modal').addClass('cookie-revoke-modal-wrap');
        $(frame).toggleClass('cookieClick', false);
    } else {
      $(frame).find('.cookie_2click').on('click', function () {
        const parent = $(this).closest('.cookie2clickElementReplacement');
        if (parent.length > 0) {
          $(`.cookie2clickElementReplacement[data-cookie-type="${parent.attr('data-cookie-type')}"]`).each(function () {
            $(this).fadeOut(300);
            setTimeout(function () {
              $(this).closest('section').find('.cookie2clickElement').fadeIn(300);
            }, 300)
          })
        } else {
          const frame2 = $(this).closest('.js-modal-iframe');

          const url = $(frame).data('frame-url');
          $(frame).removeClass('cookieClick');
          setTimeout(function () {
            $(frame2).html(`<iframe src="${url}" frameborder="0" allowfullscreen allow="xr-spatial-tracking"/>`);
            $(frame2).append($(frame2).closest('.js-modal').find('.modal_revoke').html())
            $(frame2).toggleClass('cookieClick', false);
          }, 400);
        }
      })
    }
  });

  if (videoUrl) {
    if ((allowedByCookie && $$cookieName !== '') || $el.find('.js-modal-video').hasClass('cookieClick')) {
      $el.find('.js-modal-video').html(`<iframe src="${videoUrl}" scrolling="no" allowfullscreen />`);
      $el.find('.js-modal-video').append($el.find('.modal_revoke').html())
      $($el).closest('.js-modal').addClass('cookie-revoke-modal-wrap');
    } else {
      const text = $(initiator).attr('data-cookie-text');
      const image = $(initiator).attr('data-cookie-img');
      const button = $(initiator).attr('data-cookie-button');
      const headline = $(initiator).attr('data-cookie-headline');
      const subline = $(initiator).attr('data-cookie-subline');

      if (text) {
        $el.find('.twoClickCookieTextWrapper').html(text);
      }

      if (image) {
        $el.find('.twoClickCookieImage').css('background-image', `url(${image})`);
      }

      if (button) {
        $el.find('.button_label').html(button);
      }
      if (headline) {
        $el.find('.twoClickCookieheadline').html(headline);
      }
      if (subline) {
        $el.find('.twoClickCookieSubline').html(subline);
      }

      $el.find('.js-modal-video').find('.cookie_2click').on('click', function () {
        const parent = $(this).closest('.cookie2clickElementReplacement');
        if (parent.length > 0) {
          $(`.cookie2clickElementReplacement[data-cookie-type="${parent.attr('data-cookie-type')}"]`).each(function () {
            $(this).fadeOut(300);
            setTimeout(function () {
              $(this).closest('section').find('.cookie2clickElement').fadeIn(300);
            }, 300)
          })
        } else {
          $el.find('.js-modal-video').removeClass('cookieClick');
          setTimeout(function () {
            $el.find('.js-modal-video').html(`<iframe src="${videoUrl}" scrolling="no" allowfullscreen />`);
            $el.find('.js-modal-video').append($el.find('.modal_revoke').html())
            $($el).closest('.js-modal').addClass('cookie-revoke-modal-wrap');
          }, 400);
        }
      })
    }
  }

  $hbody.addClass(noOverflow);
  $el.addClass(isActive).fadeIn();
};

const closeModal = $el => {
  $hbody.removeClass(noOverflow);
  $el.removeClass(isActive).fadeOut(() => {
    const $$frames = $el.find('.js-modal-iframe iframe');
    const $video = $el.find('.js-modal-video iframe');
    $$frames.remove();
    $video.remove();
  });
};


export const initModdalLink = el => {
  const modalId = $(el).data('modal-id');
  const $targetModal = $(`.js-modal[data-modal-id="${modalId}"]`);

  $(el).click(event => {
    event.preventDefault();

    let videoUrl = $(el).data('video-url');

    if (videoUrl) {
      videoUrl = videoUrl.replace("watch?v=", "v/");
      videoUrl = videoUrl.replace("/v/", "/embed/");
    }

    openModal($targetModal, videoUrl, el);
  });
};

const modals = () => {

  $$modals.each((i, el) => {
    const $closeBtn = $(el).find('.js-modal-close');

    $closeBtn.click(event => {
      event.preventDefault();
      closeModal($(el));
    });

    $(el).click(event => {
      if (!$(event.target).closest('.js-modal-inner').length) {
        closeModal($(el));
      }
    });

    $(el).removeClass(isHidden).hide();
  });

  $$modalLinks.each((i, el) => {
    initModdalLink(el);
  });

  $document.keydown(event => {
    if (event.which === 27) {
      $$modals.each((i, el) => {
        if ($(el).hasClass(isActive)) {
          closeModal($(el));
        }
      });
    }
  });
};

export default modals;
